import React, { FC, useCallback } from 'react'
import classNames from 'classnames'
import styles from 'styles/components/card.module.scss'
import typography from 'styles/components/typography.module.scss'
import { FlexRow } from 'components/Flex'
import { Spacer } from 'components/Utility'
import { DisabledTag, GreenTag, GreyTag } from 'components/Tag'
import { parseStoreStatus } from 'lib/helper'
import { useDispatch } from 'react-redux'
import { openModal } from 'reducks/modal/operations'
import { StoreModal } from 'components/Modal'
import { BREAD_TYPES } from 'constants/bread'
import { StockUnionType } from 'types/stock'

type Props = {
  hasScheduleTypes: StockUnionType[]
  hasStockTypes: StockUnionType[]
  imageUrl: string
  name: string
  shopId: string
  state: string
  status: string
  storeId: string
}

const StoreCard: FC<Props> = React.memo((props) => {
  const { hasScheduleTypes, hasStockTypes, imageUrl, name, shopId, state, status, storeId } = props

  const dispatch = useDispatch()

  const openStoreModal = useCallback(() => {
    dispatch(
      openModal(
        <StoreModal imageUrl={imageUrl} name={name} shopId={shopId} status={status} storeId={storeId} />,
        '',
        ''
      )
    )
  }, [imageUrl, name, status, shopId, storeId])

  return (
    <div className={classNames(styles.row__inner_clickable, 'storeCount')} onClick={openStoreModal}>
      <FlexRow justifyContent={'start'} alignItems={'start'}>
        <div className={styles.row__image}>
          <img src={imageUrl} alt={name} />
        </div>
        <Spacer size={12} />
        <div>
          <h4 className={typography.headline_small}>{name}</h4>
          <Spacer size={8} />
          <FlexRow justifyContent={'start'}>
            {status === 'public' && <GreenTag shape={'ellipse'} size={'large'} tagName={parseStoreStatus(status)} />}
            {status === 'private' && (
              <DisabledTag shape={'ellipse'} size={'large'} tagName={parseStoreStatus(status)} />
            )}
            <Spacer size={8} />
            <GreyTag shape={'ellipse'} size={'large'} tagName={state} />
          </FlexRow>
          <Spacer size={8} />
          <FlexRow justifyContent={'start'}>
            {BREAD_TYPES.map((BREAD_TYPE) => {
              const { id, name } = BREAD_TYPE
              if (!hasScheduleTypes.includes(id)) return
              return (
                <React.Fragment key={id}>
                  {hasStockTypes.includes(id) ? (
                    <GreenTag shape={'ellipse'} size={'large'} tagName={name} />
                  ) : (
                    <DisabledTag shape={'ellipse'} size={'large'} tagName={name} />
                  )}
                  <Spacer size={8} />
                </React.Fragment>
              )
            })}
          </FlexRow>
        </div>
      </FlexRow>
    </div>
  )
})

export default StoreCard
